import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import VerifyEmail from './components/auth/VerifyEmail';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPasswordCode from './components/auth/ResetPasswordCode';
import NewPassword from './components/auth/NewPassword';
import Chat from './components/chat/Chat';
import Profile from './components/profile/Profile';
import JobSearch from './components/jobsearch/JobSearch';
import JobTracking from './components/jobtracking/JobTracking';
import Subscription from './components/subscription/Subscription';
import Settings from './components/settings/Settings';
import { OnboardingPopup } from './components/onboarding/OnboardingPopup';
import PendingJobHandler from './components/PendingJobHandler';
import { authUtils } from './utils/auth';
import { ONBOARDING_COMPLETED_KEY } from './components/onboarding/types';
import './styles/onboarding.css';

// Run at module load time — before any React rendering or effects — so the
// cipher is in localStorage when PendingJobHandler's effect fires.
// Also suppress the onboarding popup immediately so it never appears for
// users who arrived via a job link (even before they register/log in).
(function extractPendingJobCipher() {
  const params = new URLSearchParams(window.location.search);
  const jobCipher = params.get('job');
  if (jobCipher) {
    authUtils.setPendingJobCipher(jobCipher);
    localStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true');
    params.delete('job');
    const newUrl = window.location.pathname +
      (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }
})();

function App() {
  return (
    <AuthProvider>
      <Router>
        <PendingJobHandler />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password-code" element={<ResetPasswordCode />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobsearch"
            element={
              <ProtectedRoute>
                <JobSearch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobtracking"
            element={
              <ProtectedRoute>
                <JobTracking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/chat" replace />} />
        </Routes>
        <OnboardingPopup />
      </Router>
    </AuthProvider>
  );
}

export default App;
